<template>
    <v-card elevation="0" class="mx-2">
        <v-card-title primary-title class="grey--text pb-1">
            <div
                v-if="isExporting && exportingProgress != 0"
                class="d-flex pb-0 pb-2 overline"
                style="width: 100%"
            >
                <div>EXPORTANDO ...</div>
                <div class="ml-auto">
                    {{ getTimeAndPercentage() }}
                </div>
            </div>
            <div
                :class="
                    $vuetify.breakpoint.smAndDown
                        ? 'primary--text text-center'
                        : 'primary--text'
                "
                style="width: 100%"
                v-else
            >
                <p class="mb-0 overline">Campos a exportar</p>
                <p class="mb-0 text-caption mt-n2">con los filtros actuales</p>
            </div>
        </v-card-title>
        <v-card-text>
            <v-row dense v-if="isExporting">
                <v-progress-linear
                    class="mt-2"
                    v-if="isExporting"
                    :value="exportingProgress"
                    :indeterminate="exportingProgress == 0"
                    height="4"
                    color="#4CAF50"
                    background-color="grey lighten-2"
                >
                </v-progress-linear>
            </v-row>
            <v-row dense v-else>
                <v-col md="12">
                    <v-select
                        v-model="spreadSheetHeaders"
                        :disabled="isExporting"
                        :error-messages="
                            spreadSheetHeaders.length == 0
                                ? 'Debe seleccionar al menos un elemento' : 
                                errorWarning ? errorWarning : ''
                        "
                        clearable
                        chips
                        deletable-chips
                        prepend-inner-icon="mdi-microsoft-excel"
                        multiple
                        :items="availableHeaders"
                        label="Seleccione campos a exportar"
                    >
                        <template v-slot:prepend-item>
                            <v-list-item
                                ripple
                                @mousedown.prevent
                                @click="toggle"
                            >
                                <v-list-item-action>
                                    <v-icon
                                        :color="
                                            availableHeaders.length > 0
                                                ? 'indigo darken-4'
                                                : ''
                                        "
                                    >
                                        {{ icon }}
                                    </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Seleccionar todos
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>


<script>
import { mapState } from 'vuex';
// import axios from 'axios'
export default {
    name: 'SpreadsheetDialog',
    data: () => ({
        elapsed: 0,
        importHeight: 300,
        tab: 0,
        errorWarning: '',
    }),
    computed: {
        IsOpenSpreadsheetDialog: {
            get() {
                return this.$store.state.teletrabajo.IsOpenSpreadsheetDialog;
            },
            set(val) {
                this.$store.commit('teletrabajo/IsOpenSpreadsheetDialog', val);
            },
        },
        spreadSheetHeaders: {
            get() {
                return this.$store.state.teletrabajo.spreadSheetHeaders;
            },
            set(val) {
                this.$store.commit('teletrabajo/spreadSheetHeaders', val);
            },
        },
        availableHeaders() {
            try {
                let elements = [];

                if (this.TableData.length > 0) {
                    Object.keys(this.TableData[0]).forEach((element) => {
                        elements.push(
                            element
                                .replace(/([A-Z])/g, ' $1')
                                .replace(/^./, function (str) {
                                    return str.toUpperCase();
                                })
                        );
                    });
                } else {
                    elements = [
                        'Id',
                        'Origen Bbdd',
                        'Nombre',
                        'Tipo Documento',
                        'Documento',
                        'Telefonos Contacto',
                        'Email',
                        'Segmento',
                        'Isp Actual',
                        'Estado',
                        'Direccion',
                        'Created On',
                        'Updated On',
                    ];
                }
                // Find last comercial and if exists delete
                const keysToDelete = [
                    'Last Comercial',
                    'Last Atencion Date',
                    'Last Atencion Contacto Date',
                ];
                keysToDelete.forEach((key) => {
                    const index = elements.indexOf(key);
                    if (index > -1) {
                        elements.splice(index, 1);
                    }
                });

                elements.push('Last Atencion');
                elements.push('Contract');

                return elements;
            } catch {}
        },
        likesAllSelection() {
            return (
                this.spreadSheetHeaders.length === this.availableHeaders.length
            );
        },
        likesSomeFruit() {
            return (
                this.spreadSheetHeaders?.length > 0 && !this.likesAllSelection
            );
        },
        icon() {
            if (this.likesAllSelection) return 'mdi-close-box';
            if (this.likesSomeFruit) return 'mdi-minus-box';
            return 'mdi-checkbox-blank-outline';
        },
        ...mapState('teletrabajo', {
            TableData: (state) => state.TableData,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
    },
    methods: {
        toggle() {
            this.$nextTick(() => {
                if (this.likesAllSelection) {
                    this.spreadSheetHeaders = [];
                } else {
                    this.spreadSheetHeaders = this.availableHeaders.slice();
                }
            });
        },
        formatTime(time) {
            let seconds = Math.floor((time / 1000) % 60);
            let minutes = Math.floor((time / (1000 * 60)) % 60);
            let hours = Math.floor((time / (1000 * 60 * 60)) % 24);

            return `${hours}h ${minutes}m ${seconds}s`;
        },
        getTimeAndPercentage(){
            if(this.exportingProgress != 0 && !isNaN(this.exportingProgress)){
                let percent = `${this.exportingProgress.toFixed(0)} %`;
                let formattedTime = this.formatTime(
                    (new Date().getTime() - this.elapsed) * (100 - this.exportingProgress) / this.exportingProgress
                );

                console.log(formattedTime);
            
                return `${percent} - ${formattedTime}`;
            }
        },
    },
    watch: {
        isExporting(val) {
            if (val) {
                this.elapsed = new Date().getTime();
            }
        },
        spreadSheetHeaders: {
            handler(val){
                if (val.includes('Contract') && val.includes('Last Atencion')) {
                    this.errorWarning = '"Contrato" y "Ultima Atencion" no pueden ser seleccionados juntos, se deseleccionara "Contrato"';
                    setTimeout(() => {
                        this.errorWarning = '';
                    }, 3000);
                    // remove last atencion
                    const index = val.indexOf('Contract');
                    if (index > -1) {
                        val.splice(index, 1);
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    }
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Kurenaido&display=swap');

.vcard-text {
    font-size: 30px;
    font-family: 'Roboto Condensed', sans-serif;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}

.overline-big-text {
    font-size: 20px;
    font-family: 'Roboto Condensed', sans-serif;
    font-weight: 200;
}
</style>
